<template>
  <v-content class="align-center">
    <v-container>
      <v-row>
        <v-col class="d-inline-flex justify-center pa-2">
          <v-card class="elevation-12">
            <v-toolbar color="primary" width="350" dark flat>
              <v-toolbar-title>Giriş Ekranı</v-toolbar-title>
              <v-spacer></v-spacer>
            </v-toolbar>
            <v-card-text>
              <v-form ref="form" v-model="valid" lazy-validation>
                <v-text-field
                  v-model="email"
                  label="Email"
                  name="email"
                  prepend-icon="fas fa-at"
                  type="text"
                  :rules="[rules.required, rules.email]"
                ></v-text-field>

                <v-text-field
                  v-model="password"
                  id="password"
                  label="Şifre"
                  name="password"
                  prepend-icon="lock"
                  type="password"
                  :rules="[rules.required, rules.counter]"
                ></v-text-field>
                <v-btn text :to="route" class="ml-4">ŞİFREMİ UNUTTUM</v-btn>
                <v-btn
                  :disabled="!valid"
                  class="ml-12"
                  color="primary"
                  @click="sendLogin"
                  >GİRİŞ</v-btn
                >
              </v-form>
            </v-card-text>
            <v-chip
              class="ma-2"
              :hidden="hideStat"
              color="red"
              text-color="white"
              label
            ></v-chip>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="d-inline-flex justify-center pa-2">
          <v-alert v-if="errorStatus" width="350" type="error"
            >Hatalı Giriş</v-alert
          >
        </v-col>
      </v-row>
    </v-container>
  </v-content>
</template>

<script>
import * as adminRequest from "../request/admin";
import { mapActions } from "vuex";
export default {
  data() {
    return {
      errorStat: [],
      route: "/forgotten",
      valid: true,
      email: "",
      password: "",
      dialog: false,
      hideStat: true,
      rules: {
        required: (value) => !!value || "Gerekli.",
        counter: (value) => value.length >= 5 || "En az 5 karakter",
        email: (value) => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "Geçersiz Email";
        },
      },
      errorStatus: false,
    };
  },
  methods: {
    ...mapActions(["changeLoginStatus"]),
    async sendLogin() {
      if (this.$refs.form.validate()) {
        let userReq = {
          email: this.email,
          password: this.password,
        };
        try {
          let response = await adminRequest.loginReq(userReq);
          if (response.data.success) {
            let isSuperAdmin = response.data.data.isSuperAdmin;
            let token = response.data.data.token;
            this.changeLoginStatus({ isSuperAdmin, isLoggedIn: true, token });
            this.$router.push("/");
          }
        } catch (error) {
          // Error 😨
          if (error.response) {
            //console.log(error.response.data);
            //console.log(error.response.status);

            this.errorStatus = true;
          }
        }
      }
    },
  },

  computed: {
  },
};
</script>
